export default __webpack_public_path__ + "static/media/close2.fc8ff503.svg";